import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Modal, TextField, IconButton, MenuItem, Select, FormControl, InputLabel, Menu, Typography } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import * as XLSX from 'xlsx';
import CommentIcon from '@mui/icons-material/Comment';
const AdminLeadGeneration = () => {

    const [adminLead, setAdminLead] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [opencommModal, setOpenCommModal] = useState(false)
    const [currentLead, setCurrentLead] = useState(null);
    const [nochangedata, setnochangedata] = useState([]);
    const [search, setSearch] = useState("");

    const [openCommentModal, setOpenCommentModal] = useState(false);
    const [selectedComments, setSelectedComments] = useState([]);

    // Function to open the modal with comments
    const handleOpenCommentModal = (comments) => {
        setSelectedComments(comments); // Split by new lines
        setOpenCommentModal(true);
    };

    // Function to close the modal
    const handleCloseCommentModal = () => {
        setOpenCommentModal(false);
    };
    useEffect(() => {
        const fetchSubAdmins = async () => {
            try {
                const response = await axios.get('/api/admin/all');
                setSubAdmins(response.data.subAdmins);
            } catch (error) {
                console.error('Error fetching admins:', error);
            }
        };
        fetchSubAdmins();
    }, []);

    const handleAssign = async (leadId, subAdminId) => {
        try {
            const response = await fetch(`/api/admin/assign/${leadId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ subAdminId }),
            });

            const data = await response.json();
            console.log("API Response:", data);

            if (data.updatedLead) {
                setAdminLead(prevLeads =>
                    prevLeads.map(lead =>
                        lead._id === leadId ? { ...lead, assignedTo: data.updatedLead.assignedTo } : lead
                    )
                );
                fetchAdminLead();
            }
        } catch (error) {
            console.error("Error assigning lead:", error);
        }
    };



    const [formData, setFormData] = useState({
        studentName: '',
        contactDetails: '',
        subjectPreference: '',
        location: '',
        comments: [],
        TypeOfClass: '',
    });

    const [subAdmins, setSubAdmins] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedLeadId, setSelectedLeadId] = useState(null);

    const [leadMetrics, setLeadMetrics] = useState({
        totalLeads: 0,
        pendingLeads: 0,
        completedLeads: 0,
        conversionRate: 0,
    });

    useEffect(() => {
        fetchAdminLead();
    }, []);

    const fetchAdminLead = async () => {
        try {
            const response = await axios.get('/api/admin/getLead');
            setAdminLead(response.data.adminLeads);

            // Calculate metrics after fetching leads
            const totalLeads = response.data.adminLeads.length;
            const pendingLeads = response.data.adminLeads.filter(lead => lead.status === 'Pending').length;
            const completedLeads = response.data.adminLeads.filter(lead => lead.status === 'Demo Completed' || lead.status === 'Demo Converted').length;
            const conversionRate = totalLeads > 0 ? (completedLeads / totalLeads) * 100 : 0;

            setLeadMetrics({
                totalLeads,
                pendingLeads,
                completedLeads,
                conversionRate: conversionRate.toFixed(2),
            });

        } catch (error) {
            console.error('Error fetching leads:', error);
        }
    };

    const handleOpenModal = (lead = null) => {
        setCurrentLead(lead);
        setFormData(lead ? lead : { studentName: '', contactDetails: '', subjectPreference: '', location: '', comments: '', TypeOfClass: '' });
        setOpenModal(true);
    };

    

    const handleCommOpenModal = (lead = null) => {
        setCurrentLead(lead);
        setFormData(lead ? lead : { studentName: '', contactDetails: '', subjectPreference: '', location: '', comments: '', TypeOfClass: '' });
        setOpenCommModal(true);
      };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleCommCloseModal = () => {
        setOpenCommModal(false);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = currentLead
            ? `/api/admin/editLead/${currentLead._id}`
            : '/api/admin/addLead';
        const method = currentLead ? 'PUT' : 'POST';

        try {
            const response = await axios({
                method,
                url,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: formData,
            });

            alert(response.data.message);
            fetchAdminLead();
            handleCloseModal();
        } catch (error) {
            console.error('Error saving lead:', error);
        }
    };

    const handleDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this lead?");

        if (!isConfirmed) {
            return; // Stop the function if user cancels
        }
        try {
            const response = await axios.delete(`/api/admin/deleteLead/${id}`);
            if (response.status === 200) {
                alert(response.data.message);
                setAdminLead(prevLeads => prevLeads.filter(lead => lead._id !== id));
            } else {
                alert("Error deleting lead");
            }
        } catch (error) {
            console.error('Error deleting lead:', error);
            alert("Error deleting lead");
        }
    };

    const handleExportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(adminLead);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Leads');
        XLSX.writeFile(wb, 'LeadsData.xlsx');
    };

    const [searchQuery, setSearchQuery] = useState("");
    const [filteredLeads, setFilteredLeads] = useState([]);
    const [selectedDateFilter, setSelectedDateFilter] = useState("");
    const [selectedCoordinator, setSelectedCoordinator] = useState("");

    useEffect(() => {
        let filtered = [...adminLead]; // Create a copy of adminLead

        // Apply search filter
        if (searchQuery.trim() !== "") {
            filtered = filtered.filter((lead) =>
                lead.studentName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                lead.contactDetails?.includes(searchQuery) ||
                lead.subjectPreference?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                lead.location?.includes(searchQuery) ||
                lead.status?.includes(searchQuery)
            );
        }

        // Apply date filter
        if (selectedDateFilter) {
            const today = new Date();
            filtered = filtered.filter((lead) => {
                if (!lead.createdAt) return false; // Ensure createdAt exists
                const leadDate = new Date(lead.createdAt);

                switch (selectedDateFilter) {
                    case "today":
                        return leadDate.toDateString() === today.toDateString();
                    case "week":
                        const lastWeek = new Date();
                        lastWeek.setDate(today.getDate() - 7);
                        return leadDate >= lastWeek;
                    case "month":
                        const lastMonth = new Date();
                        lastMonth.setMonth(today.getMonth() - 1);
                        return leadDate >= lastMonth;
                    default:
                        return true;
                }
            });
        }

        // Apply coordinator filter
        if (selectedCoordinator) {
            if (selectedCoordinator === "unassigned") {
                filtered = filtered.filter((lead) => !lead.assignedTo);
            } else {
                filtered = filtered.filter(
                    (lead) => lead.assignedTo?._id === selectedCoordinator
                );
            }
        }

        setFilteredLeads(filtered);
    }, [searchQuery, selectedDateFilter, selectedCoordinator, adminLead]);

    // Handle coordinator filter selection
    const handleCoordinatorFilter = (event) => {
        setSelectedCoordinator(event.target.value);
    };

    // Handle search input
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    // Handle date filter selection
    const handleDateFilter = (event) => {
        setSelectedDateFilter(event.target.value);
    };

     const handleCommentAdd = async (e) =>{
        e.preventDefault();
    
        if (!formData.comments.trim()) {
          alert('Please enter a comment!');
          return;
        }
        console.log( "qwertyuio",formData.comments)
    
        const payload = { comments: formData.comments.trim() };
    
        try {
          // Call the backend API to add the comment
          const res = await axios.post(`/api/admin/addComments/${currentLead._id}`, payload)
          console.log(res )
          console.log( "qwertyuio",formData.comments)
          setFormData({ comment: '' }); // Reset comment field after submission
          fetchAdminLead();
          handleCommCloseModal(); // Close the modal
        } catch (error) {
          console.error('Failed to add comment:', error);
        }
      }


    return (
        <div className='container mt-5'>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-md-3 mb-3">
                        <div className="p-3 bg-primary text-white rounded">
                            <h5>Total Leads</h5>
                            <Typography>{leadMetrics.totalLeads}</Typography>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="p-3 bg-warning text-white rounded">
                            <h5>Pending Leads</h5>
                            <Typography>{leadMetrics.pendingLeads}</Typography>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="p-3 bg-success text-white rounded">
                            <h5>Completed Leads</h5>
                            <Typography>{leadMetrics.completedLeads}</Typography>
                        </div>
                    </div>
                    <div className="col-md-3 mb-3">
                        <div className="p-3 bg-info text-white rounded">
                            <h5>Lead Conversion Rate</h5>
                            <Typography>{leadMetrics.conversionRate}%</Typography>
                        </div>
                    </div>
                </div>
            </div>


            <div className="d-flex align-items-center gap-4 mb-3">
                <div>
                    <Button
                        className="me-2"
                        variant="contained"
                        style={{ backgroundColor: "#00a695", color: "white" }}
                        onClick={() => handleOpenModal(null)}
                    >
                        Add Lead
                    </Button>

                </div>
                {/* Search Input */}
                {/* <input
        type="text"
        placeholder="Search Leads..."
        className="form-control me-2"
        style={{ maxWidth: "250px" }}
        onChange={handleSearch} // Add search handler function
    /> */}

                {/* Buttons: Add Lead & Export */}
                <div>


                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#00a695", color: "white" }}
                        onClick={handleExportToExcel}
                    >
                        Export to Excel
                    </Button>
                </div>

                {/* Date Filter Dropdown */}
                <TextField
                    label="Search"
                    variant="outlined"
                    size="small"
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ marginRight: 10 }}
                />

                <div>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <InputLabel>Date Filter</InputLabel>
                        <Select value={selectedDateFilter} onChange={handleDateFilter}>
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="today">Today</MenuItem>
                            <MenuItem value="week">Last Week</MenuItem>
                            <MenuItem value="month">Last Month</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div>
                    <FormControl size="small" sx={{ minWidth: 180 }}>
                        <InputLabel>Coordinator</InputLabel>
                        <Select value={selectedCoordinator} onChange={handleCoordinatorFilter} label="Coordinator">
                            <MenuItem value="">All Coordinators</MenuItem>
                            <MenuItem value="unassigned">Unassigned</MenuItem>
                            {subAdmins.map((subAdmin) => (
                                <MenuItem key={subAdmin._id} value={subAdmin._id}>
                                    {subAdmin.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>

            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Student Name</TableCell>
                            <TableCell>Contact Details</TableCell>
                            <TableCell>Subject Preferences</TableCell>
                            <TableCell>Location</TableCell>
                            <TableCell>ModeOf Class</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Assign Lead</TableCell>
                            <TableCell>Comments</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredLeads.map((lead, index) => (
                            <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{lead.studentName}</TableCell>
                                <TableCell>{lead.contactDetails}</TableCell>
                                <TableCell>{lead.subjectPreference}</TableCell>
                                <TableCell>{lead.location}</TableCell>
                                <TableCell>{lead.TypeOfClass}</TableCell>
                                <TableCell>{lead.status}
                                    {/* <FormControl fullWidth>
                                        <InputLabel>Status</InputLabel>
                                        <Select
                                            value={lead.status}
                                            onChange={(e) => handleChangeLeadStatus(lead._id, e.target.value)}
                                            label="Status"
                                        >
                                            <MenuItem value="Pending">Pending</MenuItem>
                                            <MenuItem value="Demo Fixed">Demo Fixed</MenuItem>
                                            <MenuItem value="Demo Completed">Demo Completed</MenuItem>
                                            <MenuItem value="Demo Converted">Demo Converted</MenuItem>
                                            <MenuItem value="Lost">Lost</MenuItem>
                                        </Select>
                                    </FormControl> */}
                                </TableCell>
                                <TableCell>
                                    <span
                                        className="me-2"
                                        style={{ color: lead.assignedTo ? '#007BFF' : 'black', fontWeight: 'bold' }}
                                    >
                                        {lead.assignedTo
                                            ? `Lead assigned to ${lead.assignedTo?.name || 'Unknown'}`
                                            : "Not assigned"}
                                    </span>

                                    <Button
                                        style={{ backgroundColor: '#00a695', color: 'white', fontSize: '12px', marginLeft: '10px' }}
                                        onClick={(event) => setAnchorEl({ [lead._id]: event.currentTarget })}
                                    >
                                        {lead.assignedTo ? "Change Assign" : "Assign"}
                                    </Button>

                                    <Menu
                                        anchorEl={anchorEl?.[lead._id] || null}
                                        open={Boolean(anchorEl?.[lead._id])}
                                        onClose={() => setAnchorEl(null)}
                                    >
                                        {subAdmins.map(subAdmin => (
                                            <MenuItem
                                                key={subAdmin._id}
                                                onClick={() => handleAssign(lead._id, subAdmin._id)}
                                            >
                                                {subAdmin.name}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </TableCell>

                                <TableCell>
                                    <Button
                                        variant="outlined"
                                        style={{ color: "#00a695", borderColor: "#00a695" }}
                                        onClick={() => handleOpenCommentModal(lead.comments)}
                                    >
                                        View
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <IconButton style={{ color: '#00a695' }} onClick={() => handleCommOpenModal(lead)}>
                                        <CommentIcon />
                                    </IconButton>
                                    <IconButton style={{ color: '#00a695' }} onClick={() => handleOpenModal(lead)}>
                                        <Edit />
                                    </IconButton>
                                    <IconButton style={{ color: 'red' }} onClick={() => handleDelete(lead._id)}>
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

              <Modal open={opencommModal} onClose={handleCommCloseModal}>
                      <Paper style={{ padding: '16px', margin: 'auto', marginTop: '16px', maxWidth: '400px' }}>
                        <h3>Add Comment</h3>
                        <form onSubmit={handleCommentAdd}>
                          <TextField
                            label="Comment"
                            name="comments"
                            // value={formData.comments} 
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            required
                          />
                          <Button
                            className='mt-2'
                            type="submit"
                            variant="contained"
                            style={{ backgroundColor: "#00a695" }}
                          >
                            Reply to SubAdmin
                          </Button>
                        </form>
                      </Paper>
                    </Modal>

            <Modal open={openModal} onClose={handleCloseModal}>
                <Paper style={{ padding: '16px', margin: 'auto', marginTop: '16px', maxWidth: '400px' }}>
                    <form onSubmit={handleSubmit}>
                        <TextField label="Student Name" name="studentName" value={formData.studentName} onChange={handleChange} fullWidth margin="normal" required />
                        <TextField label="Contact Details" name="contactDetails" value={formData.contactDetails} onChange={handleChange} fullWidth margin="normal" required />
                        <TextField label="Subject Preferences" name="subjectPreference" value={formData.subjectPreference} onChange={handleChange} fullWidth margin="normal" required />
                        <TextField label="Location" name="location" value={formData.location} onChange={handleChange} fullWidth margin="normal" required />
                        <FormControl fullWidth margin="normal" required>
                            <InputLabel>Mode of Class</InputLabel>
                            <Select
                                name="TypeOfClass"
                                value={formData.TypeOfClass}
                                onChange={handleChange}
                                label="Type of Class"
                            >
                                <MenuItem value="Online">Online</MenuItem>
                                <MenuItem value="Offline">Offline</MenuItem>
                            </Select>
                        </FormControl>
                        {/* <TextField label="Comments" name="comments" value={formData.comments} onChange={handleChange} fullWidth margin="normal" /> */}
                        <Button className='mt-2' type="submit" variant="contained" style={{ backgroundColor: "#00a695" }}>
                            {currentLead ? 'Edit' : 'Add'} Lead
                        </Button>

                    </form>
                </Paper>
            </Modal>


          
            <Modal open={openCommentModal} onClose={handleCloseCommentModal}>
                <Paper style={{ padding: '16px', margin: 'auto', marginTop: '16px', maxWidth: '400px' }}>
                    <h3>All Comments History</h3>
                    {selectedComments.length > 0 ? (
                        selectedComments.map((comment, index) => (
                            <ul key={index} style={{ marginBottom: '10px' }}>
                                <li>{comment}</li>
                            </ul>
                        ))
                    ) : (
                        <p>No comments available.</p>
                    )}
                    <Button variant="contained" color="primary" onClick={handleCloseCommentModal}>
                        Close
                    </Button>
                </Paper>
            </Modal>
        </div>
    );
};

export default AdminLeadGeneration;
